// Multi-select survey answers are imported semicolon-joined ("Coffee; Tea").
// Chart previews split them so each selected option counts once, matching the
// backend's STRING_SPLIT aggregation (widgets/chart_sql.py).

/**
 * Split a cell value into its multi-select option parts.
 * Single-valued cells (no ';') come back as a one-element array.
 */
export function splitMultiValue(raw) {
  const s = raw === null || raw === undefined ? '' : String(raw);
  if (!s.includes(';')) return [s];
  return s
    .split(';')
    .map((p) => p.trim())
    .filter((p) => p !== '');
}
